import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledCell = styled.div`
  display: inline-flex;
  align-items: center;
`;

const StyledCellIcon = styled.div`
  padding: 0 5px;
`;
const StyledCellText = styled.div``;

const DataTableBodyCellIcon = ({ icon, text }) => (
  <StyledCell>
    <StyledCellIcon>{icon}</StyledCellIcon>
    {text && <StyledCellText>{text}</StyledCellText>}
  </StyledCell>
);

DataTableBodyCellIcon.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string,
};

export default DataTableBodyCellIcon;
